module.exports = __webpack_public_path__ + "img/948.9b4f3b87.png";